import { QualityCheck } from '../types/contentValidation';
import { QcReviewName } from '../types/QualityChecks';

/**
 * Evaluates an array of quality checks and returns an overall status.
 *
 * - Ignores any checks where `applicable` is false.
 * - If any applicable check has a `status` of "NEEDS_REVIEW", returns "NEEDS_REVIEW".
 * - If all applicable checks have a `status` of "PASSED", returns "PASSED".
 * - If there are no applicable checks at all, returns "PASSED".
 *
 * @param {QualityCheck[]} checks - Array of quality check objects to evaluate.
 * @returns {"PASSED" | "NEEDS_REVIEW"} The overall validation status.
 */
const evaluateQualityChecks = (checks: QualityCheck[]): QcReviewName =>
  checks
    .filter(check => check.validations.applicable)
    .some(check => check.validations.status === QcReviewName.NEEDS_REVIEW)
    ? QcReviewName.NEEDS_REVIEW
    : QcReviewName.PASSED;

export default evaluateQualityChecks;

export const getNeedsReviewCount = (data: QualityCheck[]): number => {
  // Initialize the counter for items with status 'NEEDS_REVIEW' and 'applicable' being true
  let count = 0;

  // Iterate over each item in the data array
  data.forEach(item => {
    // Check if 'applicable' is true and the status is 'NEEDS_REVIEW'
    if (
      item.validations.applicable &&
      item.validations.status === 'NEEDS_REVIEW'
    ) {
      count += 1;
    }
  });

  return count;
};
